import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_BASE_URL from "../config";
import { useTheme } from "../context/ThemeContext";
import AddSlabModal from "../components/AddSlabModal";
import { Button } from "@mui/material"; // 🔧 a MUI gomb
import ConfirmDeleteModal from "./ConfirmDeleteModal"; // vagy "../components/ConfirmDeleteModal" attól függően, hol van
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getUserRole } from "../utils/Auth";

const ProductSlabsPage = () => {
  const { productId } = useParams();
  const [slabs, setSlabs] = useState([]);
  const [productName, setProductName] = useState("");
  const { darkMode } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [slabToDelete, setSlabToDelete] = useState(null);
  const [editingSlab, setEditingSlab] = useState(null);
  const role = getUserRole();
  const isAdmin = role === "Admin";

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      // 🔹 Slab méretek lekérése
      const slabRes = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const slabData = await slabRes.json();
      setSlabs(slabData);

      // 🔹 Termék neve
      const prodRes = await fetch(`${API_BASE_URL}/api/products/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const prodData = await prodRes.json();
      setProductName(prodData.name);
    };

    fetchData();
  }, [productId]);

  const handleAddSlab = async (newSlab) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(newSlab),
        }
      );

      if (!response.ok) throw new Error("Eroare la salvarea lastrei");

      const refreshed = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await refreshed.json();
      setSlabs(data);

      setIsModalOpen(false);
    } catch (error) {
      alert("Eroare la adăugare: " + error.message);
    }
  };

  const handleEditSlab = async (updatedSlab) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs/${editingSlab.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedSlab),
        }
      );

      if (!response.ok) throw new Error("Eroare la actualizare lastră");

      const refreshed = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await refreshed.json();
      setSlabs(data);
      setIsModalOpen(false);
      setEditingSlab(null);
    } catch (error) {
      alert("Eroare la actualizare: " + error.message);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const token = localStorage.getItem("token");
      await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs/${slabToDelete.id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // újratöltés
      const refreshed = await fetch(
        `${API_BASE_URL}/api/products/${productId}/slabs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await refreshed.json();
      setSlabs(data);
      setIsDeleteModalOpen(false);
      setSlabToDelete(null);
    } catch (error) {
      alert("Eroare la ștergere.");
    }
  };

  return (
    <div className="p-6">
      <h2
        className={`text-4xl font-bold mb-6 ${
          darkMode ? "text-white" : "text-black"
        }`}
      >
        Lastra pentru: {productName}
      </h2>

      {isAdmin && (
        <button
          onClick={() => setIsModalOpen(true)}
          className="mb-6 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-3xl font-semibold"
        >
          ➕ Adaugă lastră
        </button>
      )}

      {/* MODAL */}
      <AddSlabModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);

          setTimeout(() => {
            setEditingSlab(null);
          }, 300);
        }}
        onSave={editingSlab ? handleEditSlab : handleAddSlab}
        initialData={editingSlab}
      />

      {/* TÁBLÁZAT */}
      {slabs.length === 0 ? (
        <p className="text-gray-500">Nu există lastre pentru acest produs.</p>
      ) : (
        <table
          className={`w-full border ${
            darkMode
              ? "text-white border-gray-700"
              : "text-black border-gray-400"
          }`}
        >
          <thead className={darkMode ? "bg-gray-800" : "bg-gray-300"}>
            <tr>
              <th className="p-2 border border-gray-400">Lățime (cm)</th>
              <th className="p-2 border border-gray-400">Lungime (cm)</th>
              <th className="p-2 border border-gray-400">Cantitate</th>
              <th className="p-2 border border-gray-400">Observații</th>
              {isAdmin && (
                <th className="p-2 border border-gray-400 w-40">Acțiuni</th>
              )}
            </tr>
          </thead>
          <tbody>
            {slabs.map((slab) => (
              <tr
                key={slab.id}
                className={`text-center ${
                  darkMode ? "bg-gray-900" : "bg-white"
                } border border-gray-400`}
              >
                <td className="p-2 border border-gray-400">{slab.width}</td>
                <td className="p-2 border border-gray-400">{slab.length}</td>
                <td className="p-2 border border-gray-400">{slab.quantity}</td>
                <td className="p-2 border border-gray-400 whitespace-pre-wrap">
                  {slab.notes || "-"}
                </td>
                {isAdmin && (
                  <td className="p-2 border border-gray-400">
                    <div className="flex justify-center gap-2">
                      <Button
                        variant="outlined"
                        startIcon={<EditIcon />}
                        sx={{
                          borderColor: darkMode ? "#90caf9" : "#0056B3",
                          color: darkMode ? "#90caf9" : "#0056B3",
                          "&:hover": {
                            borderColor: darkMode ? "#90caf9" : "#003B80",
                            backgroundColor: darkMode
                              ? "rgba(144, 202, 249, 0.1)"
                              : "rgba(0, 86, 179, 0.15)",
                          },
                        }}
                        onClick={() => {
                          setEditingSlab(slab);
                          setIsModalOpen(true);
                        }}
                      >
                        Editare
                      </Button>

                      <Button
                        variant="outlined"
                        startIcon={<DeleteIcon />}
                        color="error"
                        onClick={() => {
                          setIsDeleteModalOpen(true);
                          setSlabToDelete(slab);
                        }}
                      >
                        Ștergere
                      </Button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        entityName="lastră"
      />
    </div>
  );
};

export default ProductSlabsPage;
